export default {
      id: "ic-increase-usage",
      viewBox: "0 0 23 12",
      url: "/" + "images/icons.3.109.2.svg#ic-increase-usage",
      toString: function () {
        return this.url;
      }
    }